import { useEffect, useState } from 'react';

const CONSULTA = '(min-width: 1024px)';

// Só para o que muda de lugar entre web e celular (ex.: o campo de cupom);
// o resto do layout responsivo é feito com classes.
export function useIsDesktop() {
  const [desktop, setDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(CONSULTA).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(CONSULTA);
    const ouvir = (e) => setDesktop(e.matches);
    mq.addEventListener('change', ouvir);
    return () => mq.removeEventListener('change', ouvir);
  }, []);
  return desktop;
}
